import { inject, provide } from 'vue'

import type { CarouselContext } from '@shared/fondof-ui/components/molecules/carousel/types'
import { CAROUSEL_CONTEXT_KEY } from '@shared/fondof-ui/components/molecules/carousel/useCarousel'

export const provideCarouselContext = (context: CarouselContext) => {
  provide(CAROUSEL_CONTEXT_KEY, context)
}

export const useCarouselContext = () => {
  const context = inject(CAROUSEL_CONTEXT_KEY)

  if (!context) {
    throw new Error(
      'useCarouselContext must be used within a Carousel component in CarouselContext Provider'
    )
  }

  return context
}
